// fa to en
const p2e = (v: string) =>
  v.replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString());

// ar to en
const a2e = (v: string) =>
  v.replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d).toString());

const toEn = (v: string) => [p2e, a2e].reduce((r, fn) => fn(r), v);

const e2p = (v: string) => v.replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[+d]!);

function mobile(input: string): string {
  return input.replace(/^(\+?98)?/, '0').replace(/^0?9/, '09');
}

export const formatter = {
  money(v: number | string, delimiter = ',') {
    return v.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${delimiter}`);
  },
  number: {
    p2e,
    a2e,
    toEn,
    e2p,
  },
  date: (input: string | Date) =>
    (typeof input === 'string' ? new Date(input) : input).toLocaleString(
      'fa-ir',
      {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      },
    ),
  imgSrc: (input: string) => (!/^((http)|(\/))/.test(input) ? '/' : '') + input,
  mobile,
};
